<template>
  <div>
    <v-stepper v-model="currentStep">


      <v-stepper-header>
        <v-stepper-step :complete="currentStep > 1" step="1">
          Create Username/Password login
        </v-stepper-step>

        <v-divider />

        <v-stepper-step v-if="!invitation" :complete="currentStep > 2" step="2">
          Name, Company Name, Phone Number
        </v-stepper-step>

        <v-stepper-step v-if="invitation === 'driver'" :complete="currentStep > 2" step="2">
          CDL Info
        </v-stepper-step>

        <v-divider />

        <v-stepper-step v-if="!invitation" :complete="currentStep > 2"  step="3">
          What kind of company?
        </v-stepper-step>

        <v-divider />

        <v-stepper-step step="4">
          Explore
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <form data-vv-scope="step1">
            <v-layout  class="pb-3 mb-1">
              <v-flex md6>
                <div class="subheading font-weight-bold">
                  Create account
                </div>
                <v-alert class="my-2" :value="accountErrors" type="error">
                  {{accountErrors}}
                </v-alert>
                <v-text-field label="Email address"
                              v-model="userName"
                              :disabled="signedIn"
                              :error-messages="errors.first('email', 'step1')"
                              data-vv-as="Email address"
                              data-vv-name="email"
                              data-vv-scope="step1"
                              v-validate="'required|email'">
                </v-text-field>

                <v-text-field
                  v-model="password"
                  :append-icon="showPass ? 'visibility_off' : 'visibility'"
                  :type="showPass ? 'text' : 'password'"
                  :disabled="signedIn"
                  name="password"
                  :error-messages="errors.first('password', 'step1')"
                  data-vv-name="password"
                  v-validate="'required|min:8'"
                  label="Password"
                  data-vv-as="Password"
                  data-vv-scope="step1"
                  counter
                  @click:append="showPass = !showPass"
                ></v-text-field>
              </v-flex>
            </v-layout >
          </form>

            <v-btn color="accent"
                   :loading="loadingBtn"
                   @click="nextStep('step1')">
              Continue
            </v-btn>

            <v-btn flat @click="$router.push(-1)">Cancel</v-btn>

            <v-menu offset-y>
              <v-btn slot="activator" color="primary" flat small>
                Advanced Login
              </v-btn>
              <v-list>
                <v-list-tile @click="googleSignIn">
                  <v-list-tile-title>
                    Log in with Google
                  </v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>


            <v-layout v-if="referrer.displayName">
              <v-flex class="mt-4">
                *You are being referred by {{referrer.displayName}}
              </v-flex>
            </v-layout >
        </v-stepper-content>

        <v-stepper-content v-if="!invitation" step="2">
          <form data-vv-scope="step2">
            <v-layout class="pb-3">
              <v-flex md6 xs12 px-3>
                <div class="subheading font-weight-bold">
                  Personal Information
                </div>
                <v-text-field label="Name" v-model="name"
                              :error-messages="errors.first('name', 'step2')"
                              data-vv-name="name"
                              data-vv-as="Name"
                              data-vv-scope="step2"
                              v-validate="'required'" type="text"/>

                <div class="subheading font-weight-bold mt-2">
                  Company Information
                </div>

                <v-text-field label="Company Name"
                              v-model="companyName"
                              :error-messages="errors.first('companyName', 'step2')"
                              data-vv-as="Company name"
                              data-vv-name="companyName"
                              data-vv-scope="step2"
                              v-validate="'required'" type="text"/>

                <v-text-field label="Phone Number"
                              v-model="phone"
                              data-vv-as="Phone Number"
                              data-vv-name="phone"
                              data-vv-scope="step2"
                              :error-messages="errors.first('phone', 'step2')"
                              v-validate="'required'" type="text"/>
              </v-flex>
            </v-layout>
          </form>

          <v-btn color="accent" @click="nextStep('step2')">
            Continue
          </v-btn>

          <v-btn flat @click="currentStep = 1">Back</v-btn>
        </v-stepper-content>

        <v-stepper-content v-if="invitation === 'driver'" step="2">
          <form data-vv-scope="step2">
            <v-layout class="pb-3">
              <v-flex md6 xs12 px-3>
                <div class="subheading font-weight-bold">
                  Add your CDL information to your Profile so loads can be assigned to you.
                </div>
                <v-layout>
                  <v-flex sm6 class="mr-5">
                    <v-menu
                      ref="cdlExpiresDateMenu"
                      :close-on-content-click="false"
                      v-model="cdlExpiresDateMenu"
                      :nudge-right="40"
                      :return-value.sync="cdlExpires"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px">
                      <v-text-field
                        slot="activator"
                        v-model="cdlExpires"
                        label="CDL Expires"
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                      <v-date-picker v-model="cdlExpires" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary"
                               @click="cdlExpiresDateMenu = false">
                          Cancel
                        </v-btn>
                        <v-btn flat color="primary"
                               @click="$refs.cdlExpiresDateMenu.save(cdlExpires)">
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex sm6 class="mr-5">
                    <v-menu
                      ref="medicalExpiresDateMenu"
                      :close-on-content-click="false"
                      v-model="medicalExpiresDateMenu"
                      :nudge-right="40"
                      :return-value.sync="medicalExpires"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px">
                      <v-text-field
                        slot="activator"
                        v-model="medicalExpires"
                        label="Medical Expires"
                        prepend-icon="event"
                        readonly></v-text-field>
                      <v-date-picker v-model="medicalExpires" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary"
                               @click="medicalExpiresDateMenu = false">Cancel</v-btn>
                        <v-btn flat color="primary"
                               @click="$refs.medicalExpiresDateMenu.save(medicalExpires)">
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>

              </v-flex>
            </v-layout>
          </form>

          <v-btn color="accent" @click="saveCDLInfo('step2')">
            Save
          </v-btn>

          <v-btn flat @click="currentStep = 1">Back</v-btn>
        </v-stepper-content>

        <v-stepper-content v-if="!invitation"  step="3">
          <v-layout class="pb-3">
            <v-flex md6 xs12>
              <div class="subheading font-weight-bold">
              Tell us a few things about you and {{companyName}}:
            </div>

              <v-layout row wrap class="pl-3">
                <v-flex sm6 xs12>
                  <v-checkbox v-model="companyType"
                              label="Produce Loads"
                              value="Produce Loads">
                  </v-checkbox>
                </v-flex>
                <v-flex sm6 xs12>
                  <v-checkbox v-model="companyType"
                              label="Dispatch Loads"
                              value="Dispatch Loads">
                  </v-checkbox>
                </v-flex>
                <v-flex sm6 xs12>
                  <v-checkbox v-model="companyType"
                              label="Stockyard"
                              value="Stockyard">
                  </v-checkbox>
                </v-flex>
                <v-flex sm6 xs12>
                  <v-checkbox v-model="companyType"
                              label="Kill Plant"
                              value="Kill Plant">
                  </v-checkbox>
                </v-flex>
                <v-flex sm6 xs12>
                  <v-checkbox v-model="companyType"
                              label="Trucking Company (Fleet)"
                              value="Trucking Company / Fleet">
                  </v-checkbox>
                </v-flex>
                <v-flex sm6 xs12>
                  <v-checkbox v-model="companyType"
                              label="Dispatched Driver"
                              value="Company Driver">
                  </v-checkbox>
                </v-flex>
                <v-flex sm6 xs12>
                  <v-checkbox v-model="companyType"
                              label="Owner/Operator"
                              value="Trucking Company/Owner Op">
                  </v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="pl-3">
                <v-flex sm12>
                  <v-text-field v-model="companyPosition"
                                :label="`Your Position at ${companyName}`">
                  </v-text-field>
                </v-flex>
                <v-flex sm12>
                  <v-textarea v-model="notes" :label="`Anything else about ${companyName}`">
                  </v-textarea>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-btn color="accent" @click="createTemporaryAccount">
            Create Interim Account
          </v-btn>

          <v-btn flat @click="currentStep = 2">Back</v-btn>
        </v-stepper-content>
        <v-stepper-content step="4">
          <h1 class="text-xs-center">You're set up!</h1>
            <p class="text-xs-center">
              We will contact you soon. <br>
              <span v-if="isLoadboardEnabled">While you wait, what would you like to do next?</span>
            </p>
            <v-layout row wrap v-if="isLoadboardEnabled">
              <v-flex  xs12 sm6>
                <v-flex mx-3>
                  <h2 class="text-xs-center">Post a Load</h2>
                  <p class="text-xs-center">Start getting bids on your load.</p>

                  <v-btn color="accent" to="/post-load" block>
                    Post New Load
                  </v-btn>
                </v-flex>
              </v-flex>
              <v-flex  xs12 sm6>
                <v-flex mx-3>
                  <h2 class="text-xs-center">Bid on a Load</h2>
                  <p class="text-xs-center">Find available loads to haul.</p>


                  <v-btn color="accent" to="/" block>
                    Search Load Board
                  </v-btn>
                  </v-flex>
              </v-flex>
            </v-layout>
            <v-layout v-else>
              <v-flex  xs12 sm4/>
              <v-flex  xs12 sm4>
                <v-flex mx-3>
                  <h2 class="text-xs-center">Create a Load</h2>
                  <p class="text-xs-center">Start planning your loads now.</p>

                  <v-btn color="accent" to="/post-load" block>
                    Create New Load
                  </v-btn>
                </v-flex>
              </v-flex>
            </v-layout>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import API from '@/api';
import firebase from 'firebase';
import { mapGetters, mapState } from 'vuex';
import * as types from '@/store/mutationTypes';
import pluginMixin from '@/mixins/pluginMixin';

export default {
  mixins: [
    pluginMixin,
  ],
  props: {
    invitation: {
      type: String,
      default() {
        return null;
      },
    },
    emailParam: {
      type: String,
    },
    referrerParam: {
      type: String,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      medicalExpiresDateMenu: false,
      cdlExpiresDateMenu: false,
      medicalExpires: null,
      cdlExpires: null,
      currentStep: 1,
      loadingBtn: false,
      showPass: false,
      password: null,
      userName: null,
      companyName: null,
      name: null,
      phone: null,
      companyType: [],
      companyPosition: null,
      notes: null,
      accountErrors: null,
    };
  },
  computed: {
    ...mapGetters('applications', [
      'signedIn',
      'currentUser',
    ]),
    ...mapGetters('referrals', [
      'referrer',
    ]),
    ...mapState('profiles', {
      userInfo: 'userInfo',
      userProfile: 'userProfile',
    }),
  },
  methods: {
    async createTemporaryAccount() {
      const companyData = {
        companyName: this.companyName,
        name: this.name,
        phone: this.phone,
        companyType: this.companyType,
        notes: this.notes,
        companyPosition: this.companyPosition,
        referralCode: this.referrerParam,
      };

      this.$store.commit(`applications/${types.START_LOADING}`);
      try {
        await API.company.submitTemporarySignup({ signupInfo: companyData });
        this.$store.dispatch('companies/getCompanies');
        this.$store.dispatch('profiles/getUserProfile');
        this.currentStep = this.currentStep + 1;
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.$store.commit(`applications/${types.END_LOADING}`);
      }
    },
    async saveCDLInfo() {
      try {
        this.loadingBtn = true;
        const userCDL = {
          cdlExpires: this.cdlExpires || '',
          medicalExpires: this.medicalExpires || '',
          userAuthId: this.userProfile.authProviderId,
        };

        await API.user.updateCDLInfo({ userCDL });

        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'User updated',
          timeout: 7000,
        });
        this.$router.push({ name: 'load-boards' });
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.loadingBtn = false;
      }
    },
    googleSignIn() {
      const provider = new firebase.auth.GoogleAuthProvider();
      provider.setCustomParameters({
        prompt: 'select_account',
      });
      provider.addScope('profile');
      provider.addScope('email');
      firebase.auth().signInWithPopup(provider).then(() => {
        try {
          this.createUserAction();
        } catch (error) {
          this.$store.dispatch('applications/setErrorNotification', {
            message: error.message,
          });
        }
      }).catch((error) => {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      });
    },
    async createUser() {
      try {
        await API.application.signUp({ email: this.userName, password: this.password });
        this.createUserAction();
      } catch (error) {
        this.loadingBtn = false;
        this.accountErrors = error.message;
      }
    },
    async createUserAction() {
      await this.$store.dispatch('profiles/getUserProfile');
      if (this.invitation) {
        await API.application.claimInvite({ token: this.$route.params.token });
        this.$store.dispatch('companies/getCompanies');
        this.loadingBtn = false;
        if (this.invitation === 'driver') {
          this.currentStep = this.currentStep + 1;
        } else {
          this.$router.push({ name: 'load-boards' });
        }
      } else {
        this.$store.dispatch('companies/getCompanies');
        this.loadingBtn = false;
        this.currentStep = this.currentStep + 1;
      }
    },
    nextStep(scope) {
      this.$validator.validateAll(scope).then((isValid) => {
        if (isValid) {
          if (this.currentStep === 1 && !this.signedIn) {
            // Create user
            this.loadingBtn = true;
            this.createUser();
          } else {
            this.currentStep = this.currentStep + 1;
          }
        }
      });
    },
  },
  created() {
    window.__insp.push(['tagSession', 'open_onboard']);
    this.$ga.event({
      eventCategory: 'open_section',
      eventAction: 'onboard',
    });
    if (this.invitation) {
      this.userName = this.emailParam;
    } else {
      this.userName = null;
    }

    if (this.signedIn) { // Skip step 1 if user is logged in
      this.currentStep = 2;
    }

    if (this.referrerParam) {
      this.$store.dispatch('referrals/getReferrerInfo', this.referrerParam);
    }
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/User/Onboard.vue